import { Fetch } from '../../shared/types';

export const logout = (fetch: Fetch): Promise<void> =>
  fetch(`v1/logout/session`, {
    credentials: 'include',
  });

export default logout;
